// extracted by mini-css-extract-plugin
export default {"holder":"about_holder__AGSoU"};